/**
 * lesion-excision.ts
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '#plugins/index.js'

// Components
import LesionExcisionVue from './views/lesion-excision/lesion-excision.vue'

// Composables
import { createApp } from 'vue'

// Styles
import 'unfonts.css'

import { store } from '#stores/lesion-excision.js'

async function goApp() {
    const app = createApp(LesionExcisionVue)
    registerPlugins(app, 'lesionExcision')
    await store.dbinit()
    app.mount('#app')
}

goApp()
